/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Message } from './Message';
import { Call } from './Call';
import styles from './Messages.module.scss';
import { Typography } from '@mui/material';
import moment from 'moment';

export const Messages = (props) => {
  const { idUser, messages, startDirectCall, selectedCompanyId } = props;
  const [dateMessages, setDateMessages] = useState([]);
  const [textSelected, setTextSelected] = useState();

  const onCopyMessage = () => {
    const data1 = dateMessages && new Date(dateMessages[0]);
    const data2 = dateMessages && new Date(dateMessages[dateMessages.length - 1]);

    const newArray = messages.filter(
      (item) =>
        (new Date(item.created_at) <= data1 && new Date(item.created_at) >= data2) ||
        (new Date(item.created_at) >= data1 && new Date(item.created_at) <= data2)
    );

    if (newArray && newArray.length > 1) {
      const allMessages = newArray.map(
        (item) =>
          `${item.sender_id_user.first_name} ${item.sender_id_user.last_name}, [${item.created_at}] ${item.message} `
      );
      setDateMessages([]);
      navigator.clipboard.writeText(allMessages.join());
      window.getSelection().empty();
    } else {
      setDateMessages([]);
      navigator.clipboard.writeText(textSelected);
      window.getSelection().empty();
    }
  };

  return (
    <>
      {messages &&
        Object.keys(messages)?.map((date) => (
          <>
            <Typography className={styles.date}>
              {moment(date, 'YYYY-MM-DD').format('MMM DD')}
            </Typography>
            {messages[date]?.map((message) => {
              switch (message.type) {
                case 'message':
                  return (
                    <Message
                      selectedCompanyId={selectedCompanyId}
                      setDateMessages={setDateMessages}
                      onCopyMessage={onCopyMessage}
                      setTextSelected={setTextSelected}
                      messages={messages}
                      key={message.id}
                      idUser={idUser}
                      message={message}
                      styles={styles}
                    />
                  );
                case 'call':
                  return (
                    <Call
                      key={message.id}
                      idUser={idUser}
                      message={message}
                      styles={styles}
                      startDirectCall={startDirectCall}
                      selectedCompanyId={selectedCompanyId}
                    />
                  );
                default:
                  return (
                    <Message
                      selectedCompanyId={selectedCompanyId}
                      key={message.id}
                      idUser={idUser}
                      message={message}
                      styles={styles}
                    />
                  );
              }
            })}
          </>
        ))}
    </>
  );
};
